export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const CREATE_SUBSCRIPTIONS = "CREATE_SUBSCRIPTIONS";
export const REMOVE_SUBSCRIPTION = "REMOVE_SUBSCRIPTION";
export const SIGNED_REMOVE_SUBSCRIPTION = "SIGNED_REMOVE_SUBSCRIPTION";
export const VERIFY_SUBSCRIPTION = "VERIFY_SUBSCRIPTION";
export const SIGNED_VERIFY_SUBSCRIPTION = "SIGNED_VERIFY_SUBSCRIPTION";
export const RESET_SUBSCRIPTION = "RESET_SUBSCRIPTION";
export const GET_CONTACT_SUBSCRIPTIONS = "GET_CONTACT_SUBSCRIPTIONS";
